import {Component, computed, forwardRef, input, InputSignal, signal, Signal, WritableSignal} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {NgClass} from '@angular/common';
import {IHairstyle} from "../../interfaces/hairstyle.interface";

@Component({
  selector: 'app-hairstyles-autocomplete',
  imports: [
    FormsModule,
    TranslatePipe,
    NgClass,
  ],
  templateUrl: './hairstyles-autocomplete.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HairstylesAutocomplete),
      multi: true
    }
  ]
})
export class HairstylesAutocomplete implements ControlValueAccessor {
  readonly hairstyles: InputSignal<IHairstyle[]> = input.required<IHairstyle[]>();
  label: InputSignal<string> = input('');
  placeholder: InputSignal<string> = input('');

  // Style customization inputs
  containerClass: InputSignal<string> = input('');
  inputClass: InputSignal<string> = input('');
  dropdownClass: InputSignal<string> = input('');
  itemClass: InputSignal<string> = input('');

  // Default classes
  readonly defaultInputClass = 'w-full pl-10 pr-2 py-3.5 bg-white/20 border border-white/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-white/50 placeholder-gray-200';
  readonly defaultDropdownClass = 'absolute top-full translate-y-1.5 lg:translate-y-2 w-full p-1 bg-white/80 text-black backdrop-blur-3xl border border-white/30 max-h-40 overflow-y-auto z-10 mt-1 rounded-lg';
  readonly defaultItemClass = 'px-4 py-2 hover:bg-white/40 hover:backdrop-blur-sm rounded-md flex justify-start text-left text-nowrap w-full text-sm focus:outline-none focus:ring-2 focus:ring-primary-500';

  searchTerm: WritableSignal<string> = signal('');
  filteredHairstyles: Signal<IHairstyle[]> = computed(() => {
    return this.hairstyles().filter((hairstyle: IHairstyle) => {
      return this.searchTerm().length > 0 && hairstyle.nom.toLowerCase().includes(this.searchTerm().toLowerCase());
    });
  });
  showResults: WritableSignal<boolean> = signal<boolean>(false);
  noResults: Signal<boolean> = computed(() => {
    return this.filteredHairstyles().length === 0 && this.showResults();
  });

  handleInput(): void {
    this.onChange(this.searchTerm());
    this.showResults.set(this.searchTerm().length > 0);
  }

  handleSelectHairstyle(hairstyleName: string): void {
    this.searchTerm.set(hairstyleName);
    this.showResults.set(false);
    this.onChange(hairstyleName);
    this.onTouched();
  }

  writeValue(value: any): void {
    if (value) {
      this.searchTerm.set(value);
    } else {
      this.searchTerm.set('');
    }
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(_isDisabled: boolean): void {
  }

  private onChange: (value: any) => void = () => {
  };
  private onTouched: () => void = () => {
  };
}
